import React, { useState } from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';

interface DeleteVersionDialogProps {
  onClose: () => void;
  versionLabel?: string;
  onDelete: () => Promise<void>;
  title: string;
}

export const DeleteVersionDialog: React.FC<DeleteVersionDialogProps> = ({
  onClose,
  versionLabel,
  onDelete,
  title,
}) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (versionLabel) {
      try {
        setLoading(true);
        await onDelete();
        onClose();
      } catch (e) {
        // proceed
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <ChakraConfirmationDialog
      title={title}
      handleAction={onSubmit}
      isOpen={Boolean(versionLabel)}
      disableSubmitAction={loading}
      onClose={onClose}
      actionButtonText="Delete"
      message={
        <>
          Are you sure you want to delete<b>&nbsp;{versionLabel}</b>&nbsp;and
          all its content in this Release?
        </>
      }
    />
  );
};
